import { faClock, faCheckCircle, faTag } from '@fortawesome/free-solid-svg-icons';

/**
 * Helper para obtener estilos e icono según el estado de la incidencia
 */
export const getStatusBadge = (status, isDark) => {
  switch (Number(status)) {
    case 2:
      return {
        label: 'En Progreso',
        icon: faClock,
        bg: isDark ? 'rgba(245, 158, 11, 0.15)' : '#fef3c7',
        color: isDark ? '#fbbf24' : '#b45309',
        border: isDark ? 'rgba(245, 158, 11, 0.3)' : '#fde68a'
      };
    case 3:
      return {
        label: 'Resuelta',
        icon: faCheckCircle,
        bg: isDark ? 'rgba(16, 185, 129, 0.15)' : '#d1fae5',
        color: isDark ? '#34d399' : '#047857',
        border: isDark ? 'rgba(16, 185, 129, 0.3)' : '#a7f3d0'
      };
    default:
      return {
        label: 'Abierta',
        icon: faTag,
        bg: isDark ? 'rgba(59, 130, 246, 0.15)' : '#dbeafe',
        color: isDark ? '#60a5fa' : '#1d4ed8',
        border: isDark ? 'rgba(59, 130, 246, 0.3)' : '#bfdbfe'
      };
  }
};

/**
 * Helper para obtener estilos del estado del ticket (1: Abierto, 2: Cerrado, 3: En progreso)
 */
export const getTicketStatusBadge = (status, isDark) => {
  switch (Number(status)) {
    case 2:
      return {
        label: 'Cerrado',
        bg: isDark ? 'rgba(16, 185, 129, 0.15)' : '#d1fae5',
        color: isDark ? '#34d399' : '#047857',
        border: isDark ? 'rgba(16, 185, 129, 0.3)' : '#a7f3d0'
      };
    case 3:
      return {
        label: 'En Progreso',
        bg: isDark ? 'rgba(245, 158, 11, 0.15)' : '#fef3c7',
        color: isDark ? '#fbbf24' : '#b45309',
        border: isDark ? 'rgba(245, 158, 11, 0.3)' : '#fde68a'
      };
    default:
      return {
        label: 'Abierto',
        bg: isDark ? 'rgba(59, 130, 246, 0.15)' : '#dbeafe',
        color: isDark ? '#60a5fa' : '#1d4ed8',
        border: isDark ? 'rgba(59, 130, 246, 0.3)' : '#bfdbfe'
      };
  }
};

